import { useState } from "react";
import { BasicButton } from "../../theme/Component/BasicButton";
import { DocumentViewer } from "../../theme/Component/DocumentViewer";
import { ErrorList } from "../../theme/Component/ErrorList";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _BudgetObligationFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { PrintJson } from "../../theme/Component/PrintJson";

interface Props {
    formData: any;
    objectList: any;
    onChange: Function;
    eventCreate?: Function;
}

export const CreateObligationDocument = ({ objectList, formData, onChange, eventCreate }: Props) => {

    const { instance } = useDataBean(_BudgetObligationFactory);

    const [documents, setDocuments] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);
    const [tap, setTap] = useState<number>(0);

    const crearDocumento = () => {
        instance.createOB15(formData.Beneficiary, formData.RegisterDate, formData.Consecutive, objectList, formData.Description, _single.getAccountID(), null, null, null, null, null, null, null, null, true).then(
            (resp: any) => {
                //console.log(resp)
                setDocuments(resp.DocumentURL);
                setMsgList(resp.MsgList);
                setTap(1)
            }
        ).catch(
            err => {
                toast.error(err, { autoClose: false })
            }
        )
    }

    //pude declarar variables pero no declarar mi amor por ella x2 ...

    return (
        <div className="row">
            {/* <PrintJson json={formData}/>
            <PrintJson json={objectList}/> */}
            {tap === 0 &&
                <div className="col-md-6">
                    <BasicButton disable={!formData.RegisterDate} icon="ri-article-line" eventClick={crearDocumento}>Generar Documento Obligación Presupuestal</BasicButton>
                </div>
            }
            {tap === 1 &&
                <div className="col">
                    {msgList.length > 0 &&
                        <ErrorList lista={msgList} />

                    }
                    {msgList.length === 0 && documents.length > 0 &&
                        <DocumentViewer key={documents} list={documents} />
                    }
                </div>
            }
        </div>

    )
}